var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { TimerModel } from "@/app/models/timer.model";
let TimerVue = class TimerVue extends Vue {
    constructor() {
        super(...arguments);
        this.timer = null;
    }
    created() {
    }
    ;
    mounted() {
        if (!this.endTime) {
            if (this.timer)
                this.timer.stopTimer();
            return;
        }
        ;
        this.timer = new TimerModel(this.endTime, this.onStarted, this.onFinished);
        this.timer.startTimer();
    }
    ;
    handleLockOutChanges() {
        if (!this.timer)
            return;
        if (!this.endTime) {
            this.timer.stopTimer();
            return;
        }
        this.timer.endTime = this.endTime;
    }
    ;
    get timerString() {
        return this.timer ? this.timer.timerString : "";
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], TimerVue.prototype, "label", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], TimerVue.prototype, "cssClass", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], TimerVue.prototype, "endTime", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Function)
], TimerVue.prototype, "onStarted", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Function)
], TimerVue.prototype, "onFinished", void 0);
__decorate([
    Watch("endTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TimerVue.prototype, "handleLockOutChanges", null);
TimerVue = __decorate([
    Component({
        name: "TimerVue",
    })
], TimerVue);
export default TimerVue;
